import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { Button, Box, Typography } from '@material-ui/core';
import { CircularProgress } from 'material-ui/Progress';
import Session from './Session';
import GroupIcon from '../../common/GroupIcon';
import * as CalendarState from '../../../state/reducer/calendar/calendar';
import * as SummaryState from '../../../state/reducer/summary/summary';
import * as AppState from '../../../state/reducer/app/appState';
import * as Authorization from '../../../lib/authorization';

import Console from '../../../lib/debug';

class ExtraWork extends Component {
    state = {};

    getPreview = e => {
        ReactTooltip.rebuild();
        let content = {
            id: e.pw_id,
            dataHtml: true,
            place: 'right',
            type: 'light',
            className: 'hover-session-preview'
        };
        if (this.state[e.pw_id] && this.state[e.pw_id].loaded) {
            let session = this.state[e.pw_id].preview;
            content.content = (
                <div className="hover-session">
                    <Session session={session} isHoverPreview={true} />
                </div>
            );
            CalendarState.setTooltipContent(content);
            return;
        }
        this.loadPreview(e, content);
        content.content = (
            <div className="cal-preview">
                <CircularProgress size={20} />
            </div>
        );
        CalendarState.setTooltipContent(content);
    };

    loadPreview = (e, content) => {
        if (
            (this.state[e.pw_id] && this.state[e.pw_id].loaded) ||
            (this.state[e.pw_id] && this.state[e.pw_id].loading)
        )
            return;

        let component = this;
        let newState = {};
        newState[e.pw_id] = { loading: true };
        component.setState(() => newState);

        setTimeout(function() {
            CalendarState.loadSessionPreview(e.pw_id).then(response => {
                if (!response || !response.workout_preview) return;

                ReactTooltip.rebuild();
                let newState = {};
                let logged =
                    response.athlete_summary && response.athlete_summary.length
                        ? response.athlete_summary[0].logged
                        : false;

                newState[e.pw_id] = {
                    loaded: true,
                    preview: response.workout_preview,
                    can_edit: e.can_edit && !logged
                };
                component.setState(() => newState);
                SummaryState.addAthleteCalendarSummary(
                    response.athlete_summary
                );
                content.content = (
                    <div className="hover-session">
                        <Session
                            session={response.workout_preview}
                            isHoverPreview={true}
                        />
                    </div>
                );
                CalendarState.updateTooltipContent(content);
                ReactTooltip.rebuild();
            });
        }, 0);
    };

    overrideWorkout = e => {
        if (!Authorization.publishSession.isAllowed())
            return AppState.showUnauthorizedDialog();

        if (this.state[e.pw_id] && this.state[e.pw_id].can_edit) {
            CalendarState.setTooltipContent();
            CalendarState.overrideExtraSession(
                this.props.dayKey,
                e.pw_id,
                e.workout_id
            );
        }
    };

    render() {
        Console.render('ExtraWork');
        const { extraWork, viewOptions } = this.props;
        const buttonClasses = 'layout-row layout-align-space-between-center';
        let extra = null;
        if (extraWork && extraWork.length > 0) {
            let extras = [];
            for (let i = 0; i < extraWork.length; i++) {
                let e = extraWork[i];
                if (
                    viewOptions.length > 0 &&
                    !(viewOptions.indexOf(e.team_id) === -1)
                ) {
                    continue;
                }
                let className = 'extra-work layout-row';
                if (
                    e.can_edit &&
                    (!this.state[e.pw_id] ||
                        (this.state[e.pw_id] && this.state[e.pw_id].can_edit))
                ) {
                    className += ' extra-work-editable';
                }

                extras.push(
                    <div key={'e' + i} className={className}>
                        <Button
                            data-for="topside"
                            data-tip=""
                            onMouseOver={() => this.getPreview(e)}
                            onFocus={() => this.getPreview(e)}
                            onClick={() => this.overrideWorkout(e)}
                            className={buttonClasses}
                        >
                            <Box
                                display="flex"
                                flexDirection="row"
                                width="100%"
                                alignItems="center"
                            >
                                <GroupIcon src={e.team_logo} />
                                <Box className="layout-column">
                                    <Typography className="title">
                                        {e.workout_title}
                                    </Typography>
                                    <Typography className="sub-title">
                                        {e.team_title}
                                    </Typography>
                                </Box>
                            </Box>
                        </Button>
                    </div>
                );
            }
            extra = <div className="extra-work-container">{extras}</div>;
        }

        return extra;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        extraWork: state.calendar.extraWorkTree[ownProps.dayKey],
        viewOptions: state.calendar.uiTree.calendarExtraViewOptions
    };
};

export default connect(mapStateToProps)(ExtraWork);
